module.exports = __webpack_public_path__ + "img/static-map-large.c9e5aa6.jpg";